// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upskld_people_pg_wrapper {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 64px 24px 80px;
  background-color: #f9f3fc;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Sora", sans-serif;
}

.upskld_people_pg_header_block {
  max-width: 720px;
  text-align: center;
  margin-bottom: 48px;
}

.upskld_people_pg_eyebrow {
  display: inline-block;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #b8862f;
  margin-bottom: 14px;
}

.upskld_people_pg_avatar {
  width: 164px;
  height: 184px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background: #f0e9d8;
  border: 1px solid #e8e2d2;
}

.upskld_people_pg_avatar_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upskld_people_pg_title {
  margin: 0 0 20px;
  font-size: 36px;
  font-weight: 500;
  line-height: 1.3;
  color: #1c1c1c;
  font-family: "Sora", sans-serif;
}

.upskld_people_pg_title_italic {
 font-family: "Sora", sans-serif;
  color: #550979;
}

.upskld_people_pg_subtitle {
  margin: 0;
  font-size: 15.5px;
  line-height: 1.7;
  color: #000000;
  font-weight: 400;
}

/* ---------- Slider shell ---------- */

.upskld_people_pg_slider {
  position: relative;
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.upskld_people_pg_grid {
  width: 100%;
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: 8px 4px 20px;
  /* hide native scrollbar (cross-browser) */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.upskld_people_pg_grid::-webkit-scrollbar {
  display: none;
}

.upskld_people_pg_card {
  flex: 0 0 auto;
  width: calc((100% - 3 * 24px) / 4);
  scroll-snap-align: start;
  background: #ffffff;
  border: 1px solid #e8e2d2;
  border-radius: 14px;
  padding: 32px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.upskld_people_pg_card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
}

.upskld_people_pg_avatar_text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
}

.upskld_people_pg_name {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 600;
  color: #1c1c1c;
}

.upskld_people_pg_role {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
 color: #550979;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.upskld_people_pg_tags {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.6;
  color: #000000;
  font-weight: 400;
}

/* ---------- Arrow buttons ---------- */

.upskld_people_pg_arrow {
  flex: 0 0 auto;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid #e8e2d2;
  background: #ffffff;
  color: #1c1c1c;
  font-size: 22px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.upskld_people_pg_arrow:hover:not(:disabled) {
  background: #ff00f2;
  border-color: #53005e;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgb(95, 0, 90);
}

.upskld_people_pg_arrow:active:not(:disabled) {
  transform: translateY(0);
}

.upskld_people_pg_arrow:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* Tablet */
@media (max-width: 1024px) {
  .upskld_people_pg_card {
    width: calc((100% - 24px) / 2);
  }

  .upskld_people_pg_title {
    font-size: 30px;
  }
}

/* Mobile responsive - down to 480px */
@media (max-width: 480px) {
  .upskld_people_pg_wrapper {
    padding: 48px 16px 60px;
  }

  .upskld_people_pg_slider {
    gap: 8px;
  }

  .upskld_people_pg_card {
    width: 78%;
    padding: 26px 18px;
  }

  .upskld_people_pg_arrow {
    width: 38px;
    height: 38px;
    font-size: 18px;
  }

  .upskld_people_pg_title {
    font-size: 24px;
  }

  .upskld_people_pg_subtitle {
    font-size: 14px;
  }
}

/* Mobile responsive - down to 360px */
@media (max-width: 360px) {
  .upskld_people_pg_wrapper {
    padding: 40px 12px 48px;
  }

  .upskld_people_pg_title {
    font-size: 20px;
  }

  .upskld_people_pg_avatar {
    width: 56px;
    height: 56px;
  }

  .upskld_people_pg_card {
    width: 88%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/StudentFooter/StudentFooter.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;CACC,+BAA+B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB;;yBAEuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;CACtB,cAAc;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;;;wBAIsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".upskld_people_pg_wrapper {\n  width: 100%;\n  min-height: 100vh;\n  box-sizing: border-box;\n  padding: 64px 24px 80px;\n  background-color: #f9f3fc;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: \"Sora\", sans-serif;\n}\n\n.upskld_people_pg_header_block {\n  max-width: 720px;\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.upskld_people_pg_eyebrow {\n  display: inline-block;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: #b8862f;\n  margin-bottom: 14px;\n}\n\n.upskld_people_pg_avatar {\n  width: 164px;\n  height: 184px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  background: #f0e9d8;\n  border: 1px solid #e8e2d2;\n}\n\n.upskld_people_pg_avatar_img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.upskld_people_pg_title {\n  margin: 0 0 20px;\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #1c1c1c;\n  font-family: \"Sora\", sans-serif;\n}\n\n.upskld_people_pg_title_italic {\n font-family: \"Sora\", sans-serif;\n  color: #550979;\n}\n\n.upskld_people_pg_subtitle {\n  margin: 0;\n  font-size: 15.5px;\n  line-height: 1.7;\n  color: #000000;\n  font-weight: 400;\n}\n\n/* ---------- Slider shell ---------- */\n\n.upskld_people_pg_slider {\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.upskld_people_pg_grid {\n  width: 100%;\n  display: flex;\n  gap: 24px;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  padding: 8px 4px 20px;\n  /* hide native scrollbar (cross-browser) */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.upskld_people_pg_grid::-webkit-scrollbar {\n  display: none;\n}\n\n.upskld_people_pg_card {\n  flex: 0 0 auto;\n  width: calc((100% - 3 * 24px) / 4);\n  scroll-snap-align: start;\n  background: #ffffff;\n  border: 1px solid #e8e2d2;\n  border-radius: 14px;\n  padding: 32px 22px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition:\n    transform 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n.upskld_people_pg_card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);\n}\n\n.upskld_people_pg_avatar_text {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.upskld_people_pg_name {\n  margin: 0 0 6px;\n  font-size: 17px;\n  font-weight: 600;\n  color: #1c1c1c;\n}\n\n.upskld_people_pg_role {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n color: #550979;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n}\n\n.upskld_people_pg_tags {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: #000000;\n  font-weight: 400;\n}\n\n/* ---------- Arrow buttons ---------- */\n\n.upskld_people_pg_arrow {\n  flex: 0 0 auto;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  border: 1px solid #e8e2d2;\n  background: #ffffff;\n  color: #1c1c1c;\n  font-size: 22px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    color 0.2s ease,\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.upskld_people_pg_arrow:hover:not(:disabled) {\n  background: #ff00f2;\n  border-color: #53005e;\n  color: #ffffff;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 18px rgb(95, 0, 90);\n}\n\n.upskld_people_pg_arrow:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.upskld_people_pg_arrow:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* Tablet */\n@media (max-width: 1024px) {\n  .upskld_people_pg_card {\n    width: calc((100% - 24px) / 2);\n  }\n\n  .upskld_people_pg_title {\n    font-size: 30px;\n  }\n}\n\n/* Mobile responsive - down to 480px */\n@media (max-width: 480px) {\n  .upskld_people_pg_wrapper {\n    padding: 48px 16px 60px;\n  }\n\n  .upskld_people_pg_slider {\n    gap: 8px;\n  }\n\n  .upskld_people_pg_card {\n    width: 78%;\n    padding: 26px 18px;\n  }\n\n  .upskld_people_pg_arrow {\n    width: 38px;\n    height: 38px;\n    font-size: 18px;\n  }\n\n  .upskld_people_pg_title {\n    font-size: 24px;\n  }\n\n  .upskld_people_pg_subtitle {\n    font-size: 14px;\n  }\n}\n\n/* Mobile responsive - down to 360px */\n@media (max-width: 360px) {\n  .upskld_people_pg_wrapper {\n    padding: 40px 12px 48px;\n  }\n\n  .upskld_people_pg_title {\n    font-size: 20px;\n  }\n\n  .upskld_people_pg_avatar {\n    width: 56px;\n    height: 56px;\n  }\n\n  .upskld_people_pg_card {\n    width: 88%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
